export const CONSTANTS = {
  defaultQualityReduceFactor: 0.3,
};
